type EnvType = "dev" | "test" | "beta" | "prod";
const env: EnvType = process.env.VUE_APP_ENV as EnvType;
console.log("Current env is:", env);
interface HostConfig {
  dev: string;
  test: string;
  beta?: string;
  prod: string;
}
function getHost(hostConfig: HostConfig): string {
  return hostConfig[env] || "";
}
// ------------------------------------------------

// host配置
export const host = getHost({
  dev: "http://scmsupplier-test.banggood.cn",
  test: "http://scmsupplier-test.banggood.cn",
  beta: "https://scmsupplierbeta.banggood.cn",
  prod: "https://scmsupplier.banggood.cn",
});
export const supplierMetaHost = getHost({
  dev: "http://suppliermeta-test.banggood.cn",
  // dev: "http://172.16.2.50:8080",
  //dev: "http://scmsuppliermeta-dev.banggood.cn:8080",

  test: "http://suppliermeta-test.banggood.cn",
  beta: "https://apiscm-beta.banggood.cn",
  prod: "https://apiscm.banggood.cn",
});
export const supplierSettledHost = getHost({
  dev: "http://appapi-test.ewold.cn",
  // dev: "http://172.16.2.50:8080",
  //dev: "http://supplierdev.banggood.cn/supplierSettledHost",
  //dev: "http://scmsuppliermeta-dev.banggood.cn:8080",

  test: "http://appapi-test.ewold.cn",
  beta: "https://appapibeta.ewold.cn",
  prod: "https://appapi.ewold.cn",
});

export const productHost = getHost({
  dev: "http://scmproductapi-test.banggood.cn",
  test: "http://scmproductapi-test.banggood.cn",
  beta: "https://scmproductapi.banggood.cn",
  prod: "https://scmproductapi.banggood.cn",
});

export const ewodHost = getHost({
  dev: "http://appapi-test.ewold.cn",
  test: "http://appapi-test.ewold.cn",
  beta: "https://appapibeta.ewold.cn",
  prod: "https://appapi.ewold.cn",
});
export const fileUploadHost = getHost({
  dev: "http://ppstest.banggood.cn:6030",
  test: "http://ppstest.banggood.cn:6030",
  beta: "https://apipps.banggood.cn",
  prod: "https://apipps.banggood.cn",
});
export const fileDownloadHost = getHost({
  dev: "https://img-dev.banggood.cn",
  test: "https://img-dev.banggood.cn",
  beta: "https://file.sellercube.com",
  prod: "https://file.sellercube.com",
});
